import { MapPin, Phone, Clock, Mail } from "lucide-react";
import { SITE } from "../data/site";
import { MaskText, FadeIn } from "./Reveal";

export const Location = () => {
  return (
    <section id="dove" data-testid="location" className="relative">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 py-28 md:py-40">
        <div className="grid md:grid-cols-12 gap-4 mb-16 md:mb-24">
          <div className="md:col-span-3">
            <FadeIn>
              <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-[var(--fg-dim)]">
                — Dove Siamo
              </span>
            </FadeIn>
          </div>
          <div className="md:col-span-9">
            <h2 className="font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.9] tracking-tight">
              <MaskText lines={["Nel cuore della", <span key="i" className="italic font-light">Bassa bresciana</span>]} />
            </h2>
          </div>
        </div>

        <div id="contatti" className="grid md:grid-cols-2 border-t border-[var(--line)]">
          {/* Left — info */}
          <div className="flex flex-col divide-y divide-[var(--line)] md:border-r md:border-[var(--line)]">
            <FadeIn className="py-8 md:py-10 md:pr-14">
              <div className="flex items-start gap-4">
                <MapPin size={20} strokeWidth={1.4} className="mt-1 text-[var(--fg-dim)] shrink-0" />
                <div>
                  <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-[var(--fg-dim)]">
                    Indirizzo
                  </span>
                  <p className="font-serif text-2xl md:text-3xl mt-2 leading-snug">{SITE.address}</p>
                  <a
                    data-testid="maps-link"
                    href={SITE.mapLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block mt-3 font-mono text-[11px] tracking-[0.2em] uppercase link-underline"
                  >
                    Apri in Google Maps
                  </a>
                </div>
              </div>
            </FadeIn>

            <FadeIn className="py-8 md:py-10 md:pr-14">
              <div className="flex items-start gap-4">
                <Clock size={20} strokeWidth={1.4} className="mt-1 text-[var(--fg-dim)] shrink-0" />
                <div>
                  <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-[var(--fg-dim)]">
                    Orari di apertura
                  </span>
                  <p className="font-serif text-2xl md:text-3xl mt-2">{SITE.hoursDays}</p>
                  <p className="font-mono text-sm text-[var(--fg-dim)] mt-1">{SITE.hoursTime}</p>
                  <p className="font-mono text-[11px] text-[var(--fg-dim)] mt-2">
                    {SITE.closed}
                  </p>
                </div>
              </div>
            </FadeIn>

            <FadeIn className="py-8 md:py-10 md:pr-14">
              <div className="flex items-start gap-4">
                <Phone size={20} strokeWidth={1.4} className="mt-1 text-[var(--fg-dim)] shrink-0" />
                <div>
                  <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-[var(--fg-dim)]">
                    Telefono
                  </span>
                  <a
                    data-testid="phone-link"
                    href={SITE.phoneHref}
                    className="block font-serif text-2xl md:text-3xl mt-2 link-underline w-fit"
                  >
                    {SITE.phoneDisplay}
                  </a>
                </div>
              </div>
            </FadeIn>

            <FadeIn className="py-8 md:py-10 md:pr-14">
              <div className="flex items-start gap-4">
                <Mail size={20} strokeWidth={1.4} className="mt-1 text-[var(--fg-dim)] shrink-0" />
                <div>
                  <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-[var(--fg-dim)]">
                    Email
                  </span>
                  <a
                    data-testid="email-link"
                    href={SITE.emailHref}
                    className="block font-serif text-2xl md:text-3xl mt-2 link-underline w-fit break-all"
                  >
                    {SITE.email}
                  </a>
                </div>
              </div>
            </FadeIn>
          </div>

          {/* Right — map */}
          <FadeIn className="min-h-[360px] md:min-h-full md:pl-14 md:py-10">
            <div className="relative h-full min-h-[360px] border border-[var(--line)] overflow-hidden">
              <iframe
                title="Mappa Dal Conte — Villachiara"
                data-testid="map-embed"
                src={SITE.mapEmbed}
                className="map-frame absolute inset-0 w-full h-full"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
};
